import { pdfjs } from 'react-pdf';

export async function renderPdfPageToImage(
   pdfBlob: Blob,
   pageNumber: number,
   scale: number = 2.0
): Promise<Blob> {
   const arrayBuffer = await pdfBlob.arrayBuffer();
   const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;

   if (pageNumber < 1 || pageNumber > pdf.numPages) {
      throw new Error(`Invalid page number ${pageNumber}. PDF has ${pdf.numPages} pages.`);
   }

   const page = await pdf.getPage(pageNumber);

   const viewport = page.getViewport({ scale });
   const canvas = document.createElement('canvas');
   canvas.width = viewport.width;
   canvas.height = viewport.height;

   const context = canvas.getContext('2d');
   if (!context) {
      throw new Error('Failed to get canvas 2D context');
   }

   await page.render({
      canvas,
      canvasContext: context,
      viewport
   }).promise;

   return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
         if (blob) {
            resolve(blob);
         } else {
            reject(new Error('Failed to convert canvas to blob'));
         }
      }, 'image/png');
   });
}

export async function renderPdfPageToDataUrl(
   pdfBlob: Blob,
   pageNumber: number,
   scale: number = 1.0
): Promise<string> {
   const arrayBuffer = await pdfBlob.arrayBuffer();
   const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;

   if (pageNumber < 1 || pageNumber > pdf.numPages) {
      throw new Error(`Invalid page number ${pageNumber}. PDF has ${pdf.numPages} pages.`);
   }

   const page = await pdf.getPage(pageNumber);

   const viewport = page.getViewport({ scale });
   const canvas = document.createElement('canvas');
   canvas.width = viewport.width;
   canvas.height = viewport.height;

   const context = canvas.getContext('2d');
   if (!context) {
      throw new Error('Failed to get canvas 2D context');
   }

   await page.render({
      canvas,
      canvasContext: context,
      viewport
   }).promise;

   return canvas.toDataURL('image/png');
}
